export const language = {
  en: {
    trueMoneyForm: {
      PTI: "Payment Transaction Information",
      INPUT_TITLE: "LAST 4 DIGITS OF YOUR MOBILE NUMBER",
      INPUT_PLACEHOLDER: "Enter last 4 digits of your Mobile No.",
      INPUT_ERROR: "Please enter last 4 digits of your mobile number",
      AMOUNT: "AMOUNT",
      BTN_TEXT: "Proceed to Payment",
    },
    trnxInfoCard: {
      PTI: "Payment Transaction Information",
      CARD_DESCRIPTION:
        "Please ensure the correct payment method is selected to prevent delay with processing your payment",
      BANK: "BANK",
      SELECT_BANK: "Select bank",
      ERROR_PSB: "Please select your bank",
      ACCOUNT_NO: "LAST 5 DIGITS OF YOUR ACCOUNT NUMBER",
      ERROR_EAN: "Enter a number up to 5 digits.",
      ERROR_EAN_MAX: "Please enter the last 5 digits of your account.",
      AMOUNT: "AMOUNT",
      ENTER_AMOUNT: "Enter Amount",
      ERROR_AFP: "Please enter your amount for payment",
      PROCEED_PAYMENT: "Proceed to Payment",
      NEXT_BTN_TEXT: "Next",
      PAYER_BANK_DETAILS: "Payer (Depositor) Bank Details",
    },
    confirmationAndWarning: {
      description:
        "Please check to ensure the following information is correct to prevent delays in processing your payment. Otherwise, click ‘Edit Details’ to edit.",
      editBtnText: "Edit Details",
      iAgreeBtnText: "I Agree",
    },
    warningModal: {
      WARNING: "Warning!",
      FIRST_LINE:
        "Use of Other People’s Information may result in your account being suspended. ",
      SECOND_LINE:
        "Please only use your information that you have registered with your service provider.",
      OK: "OK",
    },
    qrCodeInfo: {
      REF_NO: "Reference number",
      SQR_TO_PAY: "Scan QR to pay with your banking app",
      QR_CODE_EXPIRE: "QR Code expires in",
      REFRESH_PAGE_TEXT: "Please do not refresh this webpage",
      REDIRECT_TEXT: "You will be redirected back to merchant’s site",
      REDIRECT_TEXT2: "upon successful payment. If you are not redirected,",
      REDIRECT_LINK_TEXT: "please click here to go back",
      LINK_DESCR1:
        "You will be redirected back to merchant’s site  If you are not redirected, please click here to go back",
      LINK_DESCR2: " upon successful payment.",
      LINK_DESCR3: "If you are not redirected, please click here to go back",
      LINK_DESCR_BTN: "please click here",
      PENDING_MESSAGE: `Payment Pending - Please contact Admin support to resolve the transaction`
    },
    idrMethod: {
      selectPaymentMethod: "Please select a payment method",
      qrisMaxLimit: "*QRIS maximum limit:",
      amount: "AMOUNT (Rp)",
      next: "Next",
      alreadyExist: "This transaction already exists in the system",
      expiredId: "The transaction id is expired or no longer valid",
      contactSupport:
        "This payment channel is not available. Please contact support regarding this error",
      redirectionError:
        "Page redirection error. Please contact support if payment was made",
    },
  },
  th: {
    trueMoneyForm: {
      PTI: "ข้อมูลการทำธุรกรรมการชำระเงิน",
      INPUT_TITLE: "เบอร์มือถือ 4 หลักสุดท้าย",
      INPUT_PLACEHOLDER: "ใส่หมายเลขเบอร์มือถือ 4 หลักสุดท้าย",
      INPUT_ERROR: "กรุณาใส่หมายเลขเบอร์มือถือ 4 หลักสุดท้าย",
      AMOUNT: "จำนวน",
      BTN_TEXT: "ดำเนินการชำระเงิน",
    },
    trnxInfoCard: {
      PTI: "ข้อมูลการทำธุรกรรมการชำระเงิน",
      CARD_DESCRIPTION:
        "โปรดตรวจสอบช่องทางการโอนเงินของท่านอีกครั้ง เพื่อความรวดเร็วในการดำเนินการ หากถูกต้องกรุณากด ต่อไป",
      BANK: " ธนาคาร",
      SELECT_BANK: "เลือกธนาคาร",
      ERROR_PSB: " โปรดเลือกธนาคารของคุณ",
      ACCOUNT_NO: "หมายเลขบัญชี 5 ตัวท้าย ",
      ERROR_EAN: "ใส่หมายเลขบัญชี 5 ตัวท้าย",
      BANK_CODE_PLACEHOLDER: "ใส่หมายเลขบัญชี 5 ตัวท้าย",
      ERROR_EAN_MAX:
        "กรอกหมายเลขได้ไม่เกิน 5 หลัก. กรุณากรอกหมายเลข 5 ตัวท้ายของบัญชีของคุณ",
      AMOUNT: "จำนวน",
      ENTER_AMOUNT: "ใส่จำนวนเงิน",
      ERROR_AFP: "กรุณาระบุจำนวนเงินที่ต้องการชำระ",
      PROCEED_PAYMENT: "ดำเนินการชำระเงิน",
      NEXT_BTN_TEXT: "ต่อไป",
      PAYER_BANK_DETAILS: "ใส่ข้อมูลธนาคารของผู้ชำระเงิน(ผู้ฝาก)",
    },
    confirmationAndWarning: {
      description: `โปรดตรวจสอบเพื่อให้แน่ใจว่าข้อมูลต่อไปนี้ถูกต้องเพื่อป้องกันความล่าช้าในการประมวลผลการชำระเงินของคุณ หรือคลิก 'แก้ไขรายละเอียด' เพื่อแก้ไข`,
      editBtnText: "แก้ไขรายละเอียด",
      iAgreeBtnText: "ฉันเห็นด้วย",
    },
    warningModal: {
      WARNING: "คำเตือน!",
      FIRST_LINE: "การใช้ข้อมูลของบุคคลอื่นอาจส่งผลให้บัญชีของคุณถูกระงับ",
      SECOND_LINE:
        "โปรดใช้เฉพาะข้อมูลที่คุณได้ลงทะเบียนไว้กับผู้ให้บริการของคุณเท่านั้น",
      OK: "ตกลง",
    },
    qrCodeInfo: {
      REF_NO: "หมายเลขอ้างอิง",
      SQR_TO_PAY:
        "สแกนเพื่อชำระเงินผ่านแอปธนาคารเท่านั้น\nกรุณาอย่าใช้แอปพลิเคชัน TrueMoney Wallet เพราะอาจทำให้กระบวนการชำระเงินล่าช้าได้",
      QR_CODE_EXPIRE: "QR Code หมดอายุใน",
      REFRESH_PAGE_TEXT: "กรุณาอย่ารีเฟรชหน้านี้",
      REDIRECT_TEXT: "กลับสู่หน้าหลักอัติโนมัติ เมื่อการชําระเงินเสร็จสิ้น",
      REDIRECT_TEXT2: "หากไม่สามารถกลับสู่หน้าหลักได้",
      REDIRECT_LINK_TEXT: "โปรดคลิก",
      SQR_TO_PAY_TRUE_MONEY: "ใช้ทรูวอลเล็ทสแกนคิวอาร์โค๊ดเพื่อจ่ายเงิน",
      LINK_DESCR:
        "กลับสู่หน้าหลักอัติโนมัติ เมื่อการชำระเงินเสร็จสิ้น หากไม่สามารถกลับสู่หน้าหลักได้ โปรดคลิก",
      PENDING_MESSAGE: `การชำระเงินยังไม่เสร็จสิ้น - กรุณาติดต่อฝ่ายสนับสนุนผู้ดูแลระบบเพื่อแก้ไขการทำธุรกรรม`
    },
  },
  bi: {
    idrMethod: {
      selectPaymentMethod: "Silakan pilih metode pembayaran",
      qrisMaxLimit: "*Batas maksimum QRIS:",
      amount: "Jumlah (Rp)",
      next: "Seterusnya",
      alreadyExist: "Transaksi ini sudah ada dalam sistem",
      expiredId: "ID transaksi telah kedaluwarsa atau tidak boleh dipakai",
      contactSupport:
        "Saluran pembayaran ini tidak tersedia. Silakan hubungi dukungan mengenai kesalahan ini",
      redirectionError:
        "Kesalahan pengalihan halaman. Silakan hubungi dukungan jika pembayaran telah dilakukan",
    },
  },
};
